import React from 'react';
import { Navigate } from 'react-router-dom';
import urls from '@/constants/urls';

const HomeRedirect = () => (
  <Navigate to={`${urls.BASE}${urls.HOME}`} replace />
);

export default HomeRedirect;
